import { globalTranslate } from '@pfsc/shared/locale/app.i18n';
import { invertDictionary } from '@pfsc/core/utils/invert-dictionary';
import { LOCALE_CODE } from './locale-code';
import { lookup } from '../../../vueComponents/lookup/lookup';

const TO_READABLE_LANGUAGE = {
  EN: globalTranslate('languages.english'),
  SPA: globalTranslate('languages.spanish'),
  CHN: globalTranslate('languages.chinese'),
  KOR: globalTranslate('languages.korean'),
};

/** Maps legacy language code to locale code. */
export const LEGACY_LANGUAGE_TO_LOCALE = {
  EN: LOCALE_CODE.EN,
  SPA: LOCALE_CODE.ES,
  CHN: 'zh',
  KOR: LOCALE_CODE.KO,
};

export class Language {
  constructor(data) {
    this.id = data.id;
    this.name = data.name;
    this.code = data.code;
  }

  /**
   * Map to readable
   * @param {Language} value Value.
   * @returns {string}
   */
  static toReadable(value) {
    const readableLanguage = TO_READABLE_LANGUAGE[value.code];
    return readableLanguage ?? value.name;
  }
}

// There are no courses for Vietnamese and Japanese
/** @type {Language[]} */
export const AVAILABLE_LANGUAGES = lookup.languages.filter(l => l.code === 'EN' || l.code === 'SPA');
